enum Coefficients {
  'ANNUALY' = 12,
  'SEMIANNUALY' = 6,
  'QUARTERLY' = 3,
  'MONTHLY' = 1
}

export class PaymentFrequencyCoefficient {
  getCoefficient(PaymentFrequencyId: number): number | null {
    switch (PaymentFrequencyId) {
      case 2: return Coefficients.ANNUALY;
      case 3: return Coefficients.SEMIANNUALY;
      case 4: return Coefficients.QUARTERLY;
      case 5: return Coefficients.MONTHLY;
      default: return null

    }
  }
}
